import { usePapaParse } from "react-papaparse"

import getExportData from "./getExportData"
import createDownloadElement from "./createDownloadElement"

const AFTER_DOWNLOAD_CLEANUP_DELAY = 4e4 // 40s


const getExportAction = (getFilteredItems, fileName, columns) => {
  const { jsonToCSV } = usePapaParse()

  return () => {
    const items = getFilteredItems()
    const data = getExportData(columns, items)

    const csv = jsonToCSV(data)
    const link = createDownloadElement(`${fileName}_export`, csv)

    link.click()

    setTimeout(() => {
      const url = link.getAttribute("href")
      window.URL.revokeObjectURL(url)
    }, AFTER_DOWNLOAD_CLEANUP_DELAY)
  }
}

export default getExportAction
